import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TrainBookingForm.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { AdditionalFormSaveData, TravelBookingLoadData, VT_Travel_Types } from "../../../TravelBookingListTypes";
import TransportWidget from '../Widgets/Transport/TransportWidget';

class TrainBookingForm extends compose(_WidgetBaseSP) {
    templateString: any = template;


    private entity: TravelBookingLoadData;
    private bookingType: VT_Travel_Types;

    private transportWidgetContainer: HTMLDivElement;
    private transportWidget: MdsLax<InstanceType<typeof TransportWidget>>;

    constructor(bookingType: VT_Travel_Types) {
        super(...(arguments as unknown as []));
        this.bookingType = bookingType;
    }

    onInputChange(e): void {
        this.emit("change");
    }

    getData(): AdditionalFormSaveData {
        return this.transportWidget.getData();
    }

    prepareData(entity?: TravelBookingLoadData): void {
        this.transportWidget.prepareData(entity);
    }

    private setEntity(entity: TravelBookingLoadData): void {
        this.transportWidget.prepareData(entity);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.transportWidget = new TransportWidget(this.bookingType);
        this.UiModder.domConstruct.place(this.transportWidget.domNode, this.transportWidgetContainer);
        this.transportWidget.on("change", lang.hitch(this, this.onInputChange));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TrainBookingForm);